module.exports = __webpack_public_path__ + "static/media/thumb-up-gray-16.c593cad8.svg";